import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["SelectPortal"], null, {
        default: _withCtx(() => [
            _createVNode($setup["SelectContent"], {
                position: "popper",
                "body-lock": false,
                "side-offset": $props.sideOffset,
                "data-slot": "select-content",
                class: "z-2500 min-w-[var(--reka-select-trigger-width)] min-w-32 max-w-[min(90vw,800px)] overflow-hidden rounded-md border border-input bg-popover text-popover-foreground shadow-xs data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95"
            }, {
                default: _withCtx(() => [
                    _createVNode($setup["SelectViewport"], { class: "p-1.5 max-h-80 overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-muted-foreground/30 [&::-webkit-scrollbar-thumb:hover]:bg-muted-foreground/50" }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3 /* FORWARDED */
                    })
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["side-offset"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
